import { Helmet } from "react-helmet";


const Metadata = ({ title, desctiption, canonicalURL, jsonld }) => (
    <Helmet>
        {title && <title>{title}</title>}
        {desctiption && <meta name="description" content={desctiption} />}
        {canonicalURL && <link rel="canonical" href={canonicalURL} />}
        {
            jsonld &&
            <script type="application/ld+json">
                {typeof jsonld === "string" ? jsonld : JSON.stringify(jsonld)}
            </script>
        }
    </Helmet>

);

export default Metadata;
